/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Auto Save Modal" |
*
* @param {Automatic_Save_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_close_label = /** @type {((inputs?: Automatic_Save_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre de sauvegarde automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisches Speichern-Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale di salvataggio automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть окно автосохранения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modo de guardado automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭自动保存模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動保存モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो सेव मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Modal de Salvamento Automático")
	return /** @type {LocalizedString} */ ("Close Auto Save Modal")
});